function reload() {
  return window.history.replaceState({ unload: true }, '', window.location.href)
}

export default reload
